import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from "ngx-spinner";
@Component({
  selector: 'app-vendor',
  templateUrl: './vendor.component.html',
  styleUrls: ['./vendor.component.sass']
})
export class VendorComponent implements OnInit {

  constructor(private toastr:ToastrService,
    private spinner :NgxSpinnerService,) { }

  ngOnInit(): void {
  }


  fileReaded:any;
csv_:any;
vendorName_array=[]
vendorCity_array=[]
vendorMobile_array=[]
  getCSV_withoutLock(event:any){
    if(  event.target.files[0].type  ==  "text/csv"  ){
    this.fileReaded = event.target.files[0];
    let reader: FileReader = new FileReader();
    reader.readAsText(this.fileReaded);
    reader.onload = (e) => {
      this.csv_ = reader.result;
      let allTextLines = this.csv_.split(/\r|\n|\r/);
      let headers = allTextLines[0].split(',');
      let lines :any = [];
  
      for (let i = 0; i < allTextLines.length; i++) {
        // split content based on comma
        let data = allTextLines[i].split(',');
        if (data.length === headers.length) {
          let tarr = [];
          for (let j = 0; j < headers.length; j++) {
            tarr.push(data[j]);
          }
          lines.push(tarr);
        }
      }

   this.manageCSVDATA(lines)
  }  
  
  }else{
    this.toastr.warning('Please choose CSV file.')
  }
  
  }




  manageCSVDATA(lines=[]){

      for(let j =1; j < lines.length; j++ ){
      
        
        this.vendorName_array.push(lines[j][0])
        this.vendorCity_array.push(lines[j][1])
        this.vendorMobile_array.push(lines[j][2])
        
      }
      
      console.log(this.vendorName_array)
      console.log(this.vendorCity_array)
      console.log(this.vendorMobile_array)

  }
}
